import { GetCustomerOrdersQuery, GetCustomerRewardsOrdersQuery } from '../../graphql/camel'
import { monthDayYear } from '../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../utils/priceTools'

type CustomerOrRewardsOrder =
  | NonNullable<GetCustomerOrdersQuery['getCustomerOrders']>['orders'][number]
  | NonNullable<GetCustomerRewardsOrdersQuery['getCustomerRewardsOrders']>['orders'][number]

interface ExportOrderData {
  date: string
  orderNumber: string
  addressee?: string
  total: string
  status: string
}

export const csvDataFromOrders = (orders: CustomerOrRewardsOrder[]): ExportOrderData[] =>
  orders.reduce((acc: ExportOrderData[], order) => {
    if (!order) {
      return acc
    }
    acc.push({
      date: monthDayYear(order.date),
      orderNumber: `#${order.orderNumber}`,
      ...(order.__typename === 'CustomerOrder' && order.shippingAddress
        ? {
            addressee: order.shippingAddress.addressee ?? '',
          }
        : {}),
      total: formatAsCurrencyOrZero({ amount: order.total }),
      status: order.status,
    })
    return acc
  }, [])
